import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import styled from "styled-components"
import Button from "components/Button"

const StyledGlobalCTAButton = styled((props) => (
  <Button forwardedAs={Link} {...props} />
))`
  margin: auto 0;
  padding: 0.5rem 1rem;
  text-transform: uppercase;
  font-size: 1.4rem;
`

function GlobalCTAButton({ children, ...props }) {
  return (
    <StyledGlobalCTAButton
      size="sm"
      variant="primary"
      to="/gratis-raadgivning"
      {...props}
    >
      Gratis rådgivning
    </StyledGlobalCTAButton>
  )
}

export default GlobalCTAButton

GlobalCTAButton.defaultProps = {}
GlobalCTAButton.propTypes = {
  children: PropTypes.node,
}
